export const SET_SERVICE = 'setService'
export const SET_SERVICES = 'setServices'
export const SET_SERVICES_SIMPLE = 'setServicesSimple'
export const ADD_SERVICES_SIMPLE = 'addServicesSimple'
export const REMOVE_SERVICES_SIMPLE = 'removeServicesSimple'
export const SET_CATEGORIES = 'setCategories'
export const SET_SERVICE_ACTIVE = 'setServiceActive'
export const SERVICE_RESET = 'setReset'
export const SERVICE_RESET_STATE = 'setResetState'
export const SET_SERVICE_PAGINATION = 'setServicePagination'